import React from 'react';
import {useTypedSelector} from '@common/hooks/useTypedSelector';
import Step from '@components/PageStep';
import DetailPageHeader from '@components/DetailPageHeader';


export const Vacancies = () => {
  const {vacanciesPage} = useTypedSelector(state => state.vacancies);

  return (
    <>
      <DetailPageHeader {...vacanciesPage?.detail}/>
      {vacanciesPage?.steps?.map((item, index) => {
        const classes = !(index === vacanciesPage?.steps.length - 1) ? [] : ['inner-grid--margin-bottom'];
        return (
          <Step
            key={`step_${index}`}
            count={item.count}
            classNames={classes}
            step={item.step}
            stepChildren={item.children}
          />
        )
      })}
    </>
  )
}
